/**
 * Format a date string to Italian locale, safely.
 * Returns '—' if input is empty/invalid.
 */
export function fmtDate(s) {
  if (!s) return '—';
  const d = new Date(s);
  if (isNaN(d.getTime())) return s; // keep raw if not parseable
  return d.toLocaleDateString('it-IT');
}
